import React, { Fragment, ReactElement } from 'react'
import { Button } from '@scentregroup/ui'
import DateRangeFilter, { DateRangeFilterProps } from '../date-range-filter'
import WhatsHappeningMultiFilter, {
  WhatsHappeningMultiFilterProps,
} from '../whats-happening-multi-filter'
import trackEvent from '../../helpers/analytics-utils/track-event'
import { categories, actions } from '../../helpers/analytics-utils/constants'
import WhatsHappeningFiltersWrapper from './wrapper'
import styles from './index.module.scss'

export interface SelectedFilter {
  selectedFilters: string
  onFiltersChange: (selectedTypes: string) => void
}

interface WhatsHappeningFiltersProps {
  dateRangeProps: DateRangeFilterProps
  contentTypesProps: WhatsHappeningMultiFilterProps
  topicsProps: WhatsHappeningMultiFilterProps
  experiencesProps: WhatsHappeningMultiFilterProps
  count: number
  onResetFilters: () => void
}

const trackReset = (): void => {
  trackEvent(
    categories.WHATS_HAPPENING_FILTERS,
    actions.RESET_FILTERS,
    undefined
  )
}

const WhatsHappeningFilters = ({
  dateRangeProps,
  onResetFilters,
  contentTypesProps,
  topicsProps,
  experiencesProps,
  count,
}: WhatsHappeningFiltersProps): ReactElement => (
  <WhatsHappeningFiltersWrapper count={count}>
    <Fragment>
      <DateRangeFilter {...dateRangeProps} />
      <WhatsHappeningMultiFilter {...contentTypesProps} />
      <WhatsHappeningMultiFilter {...topicsProps} />
      <WhatsHappeningMultiFilter {...experiencesProps} />
      <div className={styles.reset}>
        <Button
          type="inferior"
          className={styles.resetButton}
          onClick={() => {
            onResetFilters()
            trackReset()
          }}
        >
          Reset filters
        </Button>
      </div>
    </Fragment>
  </WhatsHappeningFiltersWrapper>
)

export default WhatsHappeningFilters
